export default __webpack_public_path__ + "static/media/Party-hover.dfd5b5d9.svg";